import { createFileRoute } from '@tanstack/react-router';
import Employee from '../../components/Employee';
import { PERMISSION_PERSON } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';

export const Route = createFileRoute('/_authenticated/employee/')({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_PERSON, ['read'], '/unauthorized', context);

    return {
      ...context,
      documentTitle: {
        main: 'menu.employeeSettings',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: EmployeesRoute,
});

function EmployeesRoute() {
  return <Employee />;
}
